"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Network = exports.REQUEST_FAILED = void 0;
var constants_1 = require("../constants");
var log_1 = require("../utils/log");
var auth_1 = require("./auth");
var request_1 = require("./request");
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
var isSuccessRemoteConfigResponse = function isSuccessRemoteConfigResponse(res) {
  var _a, _b;
  return (_b = (_a = res) === null || _a === void 0 ? void 0 : _a.configs) === null || _b === void 0 ? void 0 : _b.length;
};
exports.REQUEST_FAILED = -999;
var Network = /** @class */function (_super) {
  __extends(Network, _super);
  function Network(config) {
    var _a;
    var _this = _super.call(this, {
      app_name: config.app_name,
      secret_key: config.secret_key,
      host: config.report_host || ((_a = constants_1.host[config.env]) !== null && _a !== void 0 ? _a : constants_1.host.test),
      env: config.env
    }) || this;
    // 初始化结束 - 用于判断是否拉取配置
    _this.inited = false;
    _this.fetchToken();
    return _this;
  }
  Network.prototype.getReportDataUrl = function (tag) {
    return "" + this.host + constants_1.API_PREFIX + "/" + this.app_name + "/tags/" + tag + "/event/json";
  };
  Network.prototype.getReportDataFileUrl = function (tag) {
    return "" + this.host + constants_1.API_PREFIX + "/" + this.app_name + "/tags/" + tag + "/event/formdata";
  };
  Network.prototype.getReportBulkUrl = function (tag) {
    return "" + this.host + constants_1.API_PREFIX + "/" + this.app_name + "/tags/" + tag + "/event/json/_bulk";
  };
  Network.prototype.getRemoteConfigUrl = function () {
    return this.host + "/dem/kose/v1/apps/" + this.app_name + "/configs/_fetch";
  };
  /** 获取远端配置
   * https://confluence.shopee.io/pages/viewpage.action?pageId=522584604
   */
  Network.prototype.fetchRemoteConfigs = function (data) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
      var url, res;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            return [4 /*yield*/, this.checkAuth()];
          case 1:
            _c.sent();
            url = this.getRemoteConfigUrl();
            return [4 /*yield*/, request_1.APIs.post({
              url: url,
              token: this.token,
              data: data
            })];
          case 2:
            res = _c.sent();
            if (isSuccessRemoteConfigResponse(res)) {
              // 
              return [2 /*return*/, {
                config: (_b = (_a = res.configs) === null || _a === void 0 ? void 0 : _a.filter(function (rConfig) {
                  return rConfig.tag === 'web-performance';
                })) === null || _b === void 0 ? void 0 : _b[0],
                sdk_spec: res.sdk_spec
              }];
            }
            return [2 /*return*/, undefined];
        }
      });
    });
  };
  /**https://confluence.shopee.io/pages/viewpage.action?pageId=434802326 */
  Network.prototype.sendRequest = function (props) {
    return __awaiter(this, void 0, void 0, function () {
      var doRequest;
      var _this = this;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, this.checkAuth()];
          case 1:
            _a.sent();
            doRequest = function doRequest() {
              return __awaiter(_this, void 0, void 0, function () {
                var reportData, _a, pageUnload, tag, url_1, res, tokenStr, url_2, res, url;
                return __generator(this, function (_b) {
                  switch (_b.label) {
                    case 0:
                      reportData = props.reportData, _a = props.pageUnload, pageUnload = _a === void 0 ? false : _a;
                      tag = reportData.tag;
                      if (!request_1.APIs.supportFetchKeepAlive) return [3 /*break*/, 2];
                      url_1 = this.getReportDataUrl(tag);
                      return [4 /*yield*/, request_1.APIs.fetchPost({
                        url: url_1,
                        data: reportData,
                        token: this.token
                      })];
                    case 1:
                      res = _b.sent();
                      log_1.Logger.info("[MDAP] post successfully - event_id " + (res === null || res === void 0 ? void 0 : res.event_id));
                      return [2 /*return*/, res];
                    case 2:
                      if (pageUnload && request_1.APIs.supportSendBeacon) {
                        tokenStr = this.token ? "?access_token=" + this.token : '';
                        url_2 = "" + this.getReportDataFileUrl(tag) + tokenStr;
                        res = request_1.APIs.sendBeacon({
                          url: url_2,
                          data: reportData
                        });
                        if (!res) {
                          // 发送失败的场景
                          return [2 /*return*/, exports.REQUEST_FAILED];
                        }
                        return [2 /*return*/];
                      }

                      if (pageUnload) {
                        // beforeunload 且不支持sendbeacon 或 fetch（keepalive）
                        return [2 /*return*/, exports.REQUEST_FAILED];
                      }
                      url = this.getReportDataUrl(tag);
                      return [2 /*return*/, request_1.APIs.postXHR({
                        url: url,
                        data: reportData,
                        token: this.token,
                        async: !pageUnload
                      })];
                  }
                });
              });
            };
            return [2 /*return*/, this.authRetryWrapper(doRequest)];
        }
      });
    });
  };
  Network.prototype.sendConfigMonitor = function (data) {
    return __awaiter(this, void 0, void 0, function () {
      var url;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, this.checkAuth()];
          case 1:
            _a.sent();
            url = this.getReportDataUrl(data.tag);
            return [4 /*yield*/, request_1.APIs.post({
              url: url,
              token: this.token,
              data: data
            })];
          case 2:
            _a.sent();
            return [2 /*return*/];
        }
      });
    });
  };
  /**
   * 批量上报
   * https://confluence.shopee.io/pages/viewpage.action?pageId=434802326
   */
  Network.prototype.sendBulk = function (props) {
    return __awaiter(this, void 0, void 0, function () {
      var url, doRequest;
      var _this = this;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, this.checkAuth()];
          case 1:
            _a.sent();
            url = this.getReportBulkUrl(props.tag);
            doRequest = function doRequest() {
              return __awaiter(_this, void 0, void 0, function () {
                var res;
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, request_1.APIs.post({
                        url: url,
                        data: {
                          events: props.data
                        },
                        token: this.token
                      })];
                    case 1:
                      res = _a.sent();
                      return [2 /*return*/, res];
                  }
                });
              });
            };
            return [2 /*return*/, this.authRetryWrapper(doRequest)];
        }
      });
    });
  };
  return Network;
}(auth_1.Auth);
exports.Network = Network;